import { useContext } from 'react';
import { useGetCompany } from '../../../../api/company';
import { Card, Field } from '../../../../layouts';
import { WorkOrderContext } from '../context/WorkOrderContext';

export default function StoreInformationCard() {

	const { order } = useContext(WorkOrderContext);
	const store = useGetCompany(order.details.dealerCompanyID);

	return (
		<>
			<Card
				header={'Store Information'}
				className="field-label-25"
			>
				<Field label={'Parent Company'} >{store.data?.parentCompanyName}</Field>
				<Field label={'Number'} >{store.data?.companyCode + ' - ' + store.data?.companyName}</Field>
				<Field label={'Address'} >{store.data?.PA_Address1}</Field>
				<Field label={''} visible={!!store.data?.PA_Address2}>{store.data?.PA_Address2}</Field>
				<Field label={''} >{store.data?.PA_City + ', ' + store.data?.PA_State + ' ' + store.data?.PA_Zip}</Field>
				<Field label={'Phone'} >{store.data?.phone}</Field>
			</Card>
		</>
	);
}
